module.exports = __webpack_public_path__ + "img/stop_btn.2726e662.png";